/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const sxStyles = {
  // The blog renders on a dark page, so the MUI default of a light grey
  // panel put white inherited text on near-white and the About copy was
  // unreadable. Explicit dark surface, explicit text colour, no inheritance
  // guessing.
  sidebarAboutBox: {
    padding: '16px',
    backgroundColor: 'rgba(108, 99, 255, 0.06)',
    border: '1px solid rgba(108, 99, 255, 0.18)',
    borderRadius: 3,
    color: '#fff',
  },
  sidebarSection: {
    marginTop: '24px',
  },
  avatar: {
    margin: '8px',
  },
};

export default function Sidebar(props) {
  const {archives, description, social, title} = props;
  // const { archives, description,  title } = props;

  return (
    <Grid item xs={12} md={4}>
      <Paper elevation={0} sx={sxStyles.sidebarAboutBox}>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography sx={{color: 'rgba(255,255,255,0.74)'}}>
          {description}
        </Typography>
      </Paper>
      {/* Pages published through the API pass no archives; the heading used
          to render anyway, leaving "Archives" with nothing beneath it. */}
      {archives && archives.length > 0 && (
        <>
          <Typography variant="h6" gutterBottom sx={sxStyles.sidebarSection}>
            Archives
          </Typography>
          {archives.map((archive) => (
            <Link
              display="block"
              variant="body1"
              href={archive.url}
              key={archive.title}
            >
              {archive.title}
            </Link>
          ))}
        </>
      )}
      <Typography variant="h6" gutterBottom sx={sxStyles.sidebarSection}>
        Social
      </Typography>
      {social.map((network) => (
        <Link display="block" variant="body1" href={network.link} key={network}>
          <Grid container direction="row" spacing={1} alignItems="center">
            <Grid item>
              {/* <network.icon /> */}
              <FontAwesomeIcon
                icon={network.icon}
                size="lg"
                style={sxStyles.avatar}
              ></FontAwesomeIcon>
            </Grid>
            <Grid item>{network.name}</Grid>
          </Grid>
        </Link>
      ))}
    </Grid>
  );
}

Sidebar.propTypes = {
  archives: PropTypes.array,
  description: PropTypes.string,
  // social: PropTypes.array,
  title: PropTypes.string,
};
